export default __webpack_public_path__ + "static/media/runnerstartfx.2f5fb199.mp3";